import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Suspense as _Suspense, normalizeClass as _normalizeClass, createSlots as _createSlots } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "mr-1" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "p-fluid"
}
const _hoisted_5 = {
  key: 1,
  class: "p-fluid"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimeVueMessage = _resolveComponent("PrimeVueMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PrimeVueColumn = _resolveComponent("PrimeVueColumn")!
  const _component_User = _resolveComponent("User")!
  const _component_PayoutMethodColumn = _resolveComponent("PayoutMethodColumn")!
  const _component_EntriesDataTable = _resolveComponent("EntriesDataTable")!
  const _component_FieldDropdown = _resolveComponent("FieldDropdown")!
  const _component_FieldDropdownAutoComplete = _resolveComponent("FieldDropdownAutoComplete")!
  const _component_Entries = _resolveComponent("Entries")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.showTerms)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_PrimeVueMessage, { severity: "info" }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                innerHTML: _ctx.$t(_ctx.payoutInfo)
              }, null, 8, _hoisted_1)
            ]),
            _: 1
          }),
          _createVNode(_component_PrimeVueMessage, {
            class: "bg-blue-100",
            severity: "info"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('you_can_manage_payout_information')), 1),
              _createVNode(_component_router_link, { to: "/profile" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('profile')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ], 64))
      : _createCommentVNode("", true),
    _createVNode(_component_Entries, {
      title: _ctx.$t(_ctx.title_translate_key),
      "show-add-button": !_ctx.user.isAffiliate(),
      "show-filters-button": (_ctx.showProjectColumn || _ctx.showUserColumn) && !_ctx.user.isAffiliate(),
      "href-prefix": "payouts"
    }, _createSlots({
      tables: _withCtx(() => [
        _createVNode(_component_EntriesDataTable, {
          entries: _ctx.payouts,
          "entries-handler": _ctx.fetchPayouts,
          "href-prefix": "payouts"
        }, {
          columns: _withCtx(() => [
            _createVNode(_component_PrimeVueColumn, {
              field: "id",
              header: "ID",
              sortable: ""
            }),
            (_ctx.showProjectColumn && _ctx.user.isSuperAdmin())
              ? (_openBlock(), _createBlock(_component_PrimeVueColumn, {
                  key: 0,
                  field: "project_id",
                  header: _ctx.$t('project'),
                  sortable: ""
                }, {
                  body: _withCtx(({ data }) => [
                    _createTextVNode(_toDisplayString(data.project.name), 1)
                  ]),
                  _: 1
                }, 8, ["header"]))
              : _createCommentVNode("", true),
            (_ctx.showUserColumn && !_ctx.user.isAffiliate())
              ? (_openBlock(), _createBlock(_component_PrimeVueColumn, {
                  key: 1,
                  field: "user_id",
                  header: _ctx.$t('user'),
                  sortable: ""
                }, {
                  body: _withCtx(({ data }) => [
                    (_openBlock(), _createBlock(_Suspense, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_User, {
                          user: data.user,
                          "statistics-filters": { date_from: data.date_from, date_to: data.date_to }
                        }, null, 8, ["user", "statistics-filters"])
                      ]),
                      fallback: _withCtx(() => [
                        _createVNode(_component_PrimeVueColumn, { height: "10px" })
                      ]),
                      _: 2
                    }, 1024))
                  ]),
                  _: 1
                }, 8, ["header"]))
              : _createCommentVNode("", true),
            (!_ctx.user.isAffiliate())
              ? (_openBlock(), _createBlock(_component_PrimeVueColumn, {
                  key: 2,
                  field: "type",
                  header: _ctx.$t('type'),
                  sortable: ""
                }, {
                  body: _withCtx(({ data }) => [
                    _createTextVNode(_toDisplayString(_ctx.$t(_ctx.PAYOUT_TYPES_MAP[data.type].translate_key)), 1)
                  ]),
                  _: 1
                }, 8, ["header"]))
              : _createCommentVNode("", true),
            _createVNode(_component_PrimeVueColumn, {
              field: "date_from",
              header: _ctx.$t('period'),
              sortable: ""
            }, {
              body: _withCtx(({ data }) => [
                _createTextVNode(_toDisplayString(data.date_from_pretty) + " - " + _toDisplayString(data.date_to_pretty), 1)
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_PrimeVueColumn, {
              field: "amount",
              header: _ctx.$t('amount'),
              sortable: ""
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("span", null, _toDisplayString(_ctx.$n(data.amount, 'payout')), 1),
                (data.extra_amount)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass(["ml-2", { 'text-green-400': data.extra_amount > 0, 'text-pink-400': data.extra_amount < 0 }])
                    }, [
                      (data.extra_amount > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "+"))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$n(data.extra_amount, 'payout')), 1)
                    ], 2))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_PrimeVueColumn, {
              field: "payout_method",
              header: _ctx.$t('method'),
              sortable: ""
            }, {
              body: _withCtx(({ data }) => [
                (_openBlock(), _createBlock(_Suspense, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_PayoutMethodColumn, { entry: data }, null, 8, ["entry"])
                  ]),
                  fallback: _withCtx(() => [
                    _createVNode(_component_PrimeVueColumn, { height: "10px" })
                  ]),
                  _: 2
                }, 1024))
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_PrimeVueColumn, {
              field: "updated_at",
              header: _ctx.$t('updated_at'),
              sortable: ""
            }, {
              body: _withCtx(({ data }) => [
                _createTextVNode(_toDisplayString(data.updated_at_pretty), 1)
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_PrimeVueColumn, {
              field: "paid_at",
              header: _ctx.$t('paid_at'),
              sortable: ""
            }, {
              body: _withCtx(({ data }) => [
                (data.paid_at)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(data.paid_at_pretty), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode("—")
                    ], 64))
              ]),
              _: 1
            }, 8, ["header"])
          ]),
          _: 1
        }, 8, ["entries", "entries-handler"])
      ]),
      _: 2
    }, [
      (_ctx.showProjectColumn || _ctx.showUserColumn)
        ? {
            name: "filters",
            fn: _withCtx(() => [
              (_ctx.showProjectColumn && _ctx.user.isSuperAdmin())
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_FieldDropdown, {
                      modelValue: _ctx.payoutsFilters.project_id,
                      "onUpdate:modelValue": [
                        _cache[0] || (_cache[0] = ($event: any) => ((_ctx.payoutsFilters.project_id) = $event)),
                        _ctx.onProjectChange
                      ],
                      modelModifiers: { number: true },
                      label: _ctx.$t('project'),
                      loading: _ctx.projectsLoading,
                      "show-clear": true,
                      options: _ctx.projects.data,
                      "option-value": "id",
                      "option-label": "name",
                      "option-label-translate": false
                    }, null, 8, ["modelValue", "label", "loading", "options", "onUpdate:modelValue"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showUserColumn && !_ctx.user.isAffiliate())
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_component_FieldDropdownAutoComplete, {
                      modelValue: _ctx.payoutsFilters.user_id,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.payoutsFilters.user_id) = $event)),
                      modelModifiers: { number: true },
                      name: "user_id",
                      label: _ctx.$t('user'),
                      "show-clear": "",
                      "api-url": "/api/v3/users/options",
                      "api-params": _ctx.usersParams,
                      "option-label": "compiled_name"
                    }, null, 8, ["modelValue", "label", "api-params"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["title", "show-add-button", "show-filters-button"])
  ], 64))
}